export default {

  // 首页
  header: {
    home: '首页',
    products: '产品中心',
    omdService: 'ODM服务',
    about: '关于我们',
    contact: '联系我们',
  },

  // 首页 
  homePage: {
    carousel: {
      getSolution: "立即咨询定制方案",
      slides: [
        { img: require('@/assets/homePage/homeCarousel/01.jpg') },
        { img: require('@/assets/homePage/homeCarousel/02.jpg') },
        { img: require('@/assets/homePage/homeCarousel/03.jpg') },
        { img: require('@/assets/homePage/homeCarousel/04.jpg') },
      ]
    },
    productCenter: {
      title: '产品中心',
      viewMore: '查看更多',
      tabs: [
        {
          tab: 0,
          img: require('@/assets/homePage/productSection/p1-001.png'),
          title: '运动装备'
        },
        {
          tab: 1,
          img: require('@/assets/homePage/productSection/p2-001.png'),
          title: '筋膜放松'
        },
        {
          tab: 2,
          img: require('@/assets/homePage/productSection/p3-001.png'),
          title: '健康检测'
        }
      ]
    },

    about: {
      title: '关于我们',
      companyName: '惠州兴为智能科技有限公司',
      description: '惠州兴为智能科技',
      descriptions: '惠州兴为智能科技有限公司成立于2021年，是一家聚焦“运动健康”领域的国家高新技术企业。公司拥有8000㎡自主厂房、150+专业团队(涵盖设计、研发、生产、售后)，构建“研发-生产-服务”一体化能力，形成“自主研发+定制服务”双轮驱动模式，能够提供“运动装备-放松按摩-健康检测”全链路产品解决方案。',
      moreButton: '查看更多',

      stats: [
        { number: '8000m²', label: '厂房面积' },
        { number: '150+人', label: '专业团队' },
        { number: '20+项', label: '专利' },
        { number: '200万+台', label: '年产能' },
        { number: '8条', label: '组装线' },
        { number: '2021年', label: '公司成立' }
      ]
    },
  },

  productCenter: {
    title: "产品中心",
    subtitle: "一站式全链条服务体系，专业设计研发打造定制化解决方案。",
    tabs: [
      {
        key: 'sports',
        label: '运动装备',
        products: [
          { img: require('@/assets/productCenter/sport01.png'), title: '单机版呼啦圈' },
          { img: require('@/assets/productCenter/sport02.png'), title: '智能LED灯呼啦圈' },
          { img: require('@/assets/productCenter/sport03.png'), title: '智能彩屏呼啦圈' },
          { img: require('@/assets/productCenter/sport04.png'), title: 'LED灯跳绳' },
          { img: require('@/assets/productCenter/sport05.png'), title: '智能跳绳' },
          { img: require('@/assets/productCenter/sport06.png'), title: '智能跳绳' },
          { img: require('@/assets/productCenter/sport07.png'), title: '智能彩屏跳绳' },
          { img: require('@/assets/productCenter/sport08.png'), title: '中考跳绳' },
          { img: require('@/assets/productCenter/sport09.png'), title: '儿童跳绳' }
        ]
      },
      {
        key: 'module',
        label: '筋膜放松',
        products: [
          { img: require('@/assets/productCenter/module01.png'), title: '电动筋膜球' },
          { img: require('@/assets/productCenter/module02.png'), title: '电动花生球' },
          { img: require('@/assets/productCenter/module03.png'), title: '热敷小筋膜枪' },
          { img: require('@/assets/productCenter/module04.png'), title: '筋膜枪' },
          { img: require('@/assets/productCenter/module05.png'), title: '筋膜枪' },
          { img: require('@/assets/productCenter/module06.png'), title: '筋膜枪' },
        ]
      },
      {
        key: 'industry',
        label: '健康检测',
        products: [
          { img: require('@/assets/productCenter/screen01.png'), title: '体重称' },
          { img: require('@/assets/productCenter/screen02.png'), title: '体脂称' },
          { img: require('@/assets/productCenter/screen03.png'), title: '体脂称' },
          { img: require('@/assets/productCenter/screen04.png'), title: '体脂称' },
          { img: require('@/assets/productCenter/screen05.png'), title: '体脂称(WiFi)' },
          { img: require('@/assets/productCenter/screen06.png'), title: 'ITO镀膜 体脂称' },
          { img: require('@/assets/productCenter/screen07.png'), title: 'ITO镀膜 体脂称' },
          { img: require('@/assets/productCenter/screen08.png'), title: '八电极 体脂称' },
          { img: require('@/assets/productCenter/screen09.png'), title: '太阳能 体脂称' },
        ]
      }
    ]
  },

  contactUs: {
    carousel: {
      image: require('@/assets/contactUs/new_carousel.jpg'),
      alt: '联系我们',
      title_chi: '联系我们',
      title_eng: 'Contact us',
    },
    info: {
      desc: '<span class="desc_bold">招纳人才</span><br /><br />无论你是谁，来自何方，有何专长，只要心怀积极、敢于拼搏，你，就是我们寻觅的伙伴!<br />在这里，天空任你翱翔，海洋随你畅游，疆土由你驰骋。这里，是创意的无界天地，是才华的施展舞台。<br />我们所求，唯有你的热忱与智慧。<br />诚邀加入，携手奋进，共享收获的喜悦。我们，静候你的到来!',
      items: [
        { label: '联系人', value: '刘小姐', icon: require('../../assets/contactUs/person.png') },
        { label: '微信yanxing', value: '18126338737', icon: require('../../assets/contactUs/wechat.png') },
        { label: '邮箱', value: 'sales@yxted.com', icon: require('../../assets/contactUs/email.png') },
        { label: '地址', value: '广东省惠州市惠城区潼湖<br>数字科创产业园8栋', icon: require('../../assets/contactUs/address.png') }
      ],
      map: {
        address: '地址:广东省惠州市惠城区潼湖数字科创产业园8栋',
      },
    },
    contactForm: {
      title: '留下您的问题,我们会及时响应给到您回复',
      emailPlaceholder: '邮箱:',
      subjectPlaceholder: '留言标题:',
      messagePlaceholder: '留言内容:',
      submitButton: '确认提交'
    },
  },



  aboutUs: {
    carousel: {
      image: require('@/assets/aboutUs/carousel.jpg'),
      alt: '公司大图'
    },

    intro: {
      title: '公司介绍',
      companyName: '惠州兴为智能科技有限公司',
      description: '&emsp;&emsp;惠州兴为智能科技有限公司成立于2021年，是一家聚焦“运动健康”领域的国家高新技术企业。公司拥有8000㎡自主厂房、150+专业团队(涵盖设计、研发、生产、售后)，构建“研发-生产-服务”一体化能力，形成“自主研发+定制服务”双轮驱动模式，能够提供“运动装备-放松按摩-健康检测”全链路产品解决方案。<br>&emsp;&emsp;兴为智能始终以创新为核心引擎，累计获得20+项专利，通过“硬件+软件+数据”的深度融合，推动产品从单一功能向“智能生态”升级。<br>&emsp;&emsp;未来，公司将继续以技术创新为支撑，以用户需求为导向，深化“运动健康全场景解决方案”能力，助力用户实现“运动-放松-健康管理”的全周期科学化，在运动健康方面，成为全球领先的智能硬件产品提供商。',
      introduceImage: require('@/assets/aboutUs/introduce.jpg'),
      stats: [
        { number: '8000m²', label: '厂房面积' },
        { number: '150+人', label: '专业团队' },
        { number: '20+项', label: '专利' },
        { number: '200万+台', label: '年产能' },
        { number: '8条', label: '组装线' },
        { number: '2021年', label: '公司成立' }
      ]
    },

    video: {
      backgroundImage: require('@/assets/aboutUs/vedio_bg.png'),
      playButtonImage: require('@/assets/aboutUs/vedio_btn.png'),
      playButtonAlt: '播放视频',
      unsupportedMessage: '您的浏览器不支持视频播放。'
    },

    culture: {
      title: '公司文化',
      visionAlt: '愿景',
      vision: '愿景',
      visionDesc: '为全球千万家庭健康提供优质的产品与服务',
      missionAlt: '使命',
      mission: '使命',
      missionDesc: '用创新提升产品性能，用产品提升生活品质',
      coreValuesAlt: '核心价值观',
      coreValues: '核心价值观',
      coreValuesDesc: '开放包容、合作共赢<br/>自我驱动，重诚敢当'
    },

    laboratory: {
      title: '我们的实验室',
      devices: [
        { img: require('@/assets/aboutUs/devices_all/dev01.png'), label: '线材摇摆试验机' },
        { img: require('@/assets/aboutUs/devices_all/dev02.png'), label: '恒温恒湿试验箱' },
        { img: require('@/assets/aboutUs/devices_all/dev03.png'), label: '冷热冲击试验箱' },
        { img: require('@/assets/aboutUs/devices_all/dev04.png'), label: '斜塔紫外耐候实验机' },
        { img: require('@/assets/aboutUs/devices_all/dev05.png'), label: '盐雾试验机' },
        { img: require('@/assets/aboutUs/devices_all/dev06.png'), label: '模拟运输振动台' },
        { img: require('@/assets/aboutUs/devices_all/dev07.png'), label: '单臂跌落试验机' },
        { img: require('@/assets/aboutUs/devices_all/dev08.png'), label: '电磁振动台' },
        { img: require('@/assets/aboutUs/devices_all/dev09.png'), label: 'RCA纸带耐磨试验机' },

        { img: require('@/assets/aboutUs/devices_all/dev10.png'), label: '多功能酒精耐磨擦试验机' },
        { img: require('@/assets/aboutUs/devices_all/dev11.png'), label: '熔融指数测定仪' },
        { img: require('@/assets/aboutUs/devices_all/dev12.png'), label: '拉力试验机' },
      ]
    }
  },


  odm: {
    odmCarousel: {
      title: '提供全链路产品解决方案'
    },
    odmIntroduce: {
      title: 'ODM服务介绍',
      subtitle: '一张图看懂什么是ODM',
      introImg: require('@/assets/solution/introduce.png'),
    },
    serviceDeliver: {
      sectionTitle: '我们能提供什么？',
      desc: '依托20+项专利技术、100+客户量产经验和知名品牌验证，能够提供“运动装备-放松按摩-健康检测”全链路产品解决方案。',
      cards: [
        {
          title: '全链路产品解决方案',
          text: '提供“运动装备-放松按摩-健康检测”全链路产品解<br>决方案。'
        },
        {
          title: '一体化',
          text: '拥有构建“研发-生产-服务”一体化能力。'
        },
        {
          title: '双轮驱动模式',
          text: '“自主研发+定制服务”双轮驱动模式。'
        }
      ]
    },
  },
  
  footer: {
    info: {
      phone: '18126338737',
      contact_person: '联系人:&emsp;刘小姐',
      email: "邮&emsp;箱:&emsp;sales{'@'}yxted.com",
      address: '<div class="address-container"><span class="address-label">地&emsp;址:&emsp;</span><span class="address-content">广东省惠州市惠城区潼湖数字科创产业园8栋</span></div>',
    },

    products: {
      title: '产品中心',
      sport: '运动装备',
      module: '筋膜放松',
      screen: '健康检测',
    },

    odmService: {
      title: 'ODM服务',
      omd: 'ODM服务',
      advantage: '我们的优势',
      laboratory: '我们的实验室',
    },

    about: {
      title: '关于我们',
      company: '公司介绍',
      vedio: '视频介绍',
      culture: '公司文化',
    },
    contact: {
      title: '联系我们',
      informa: '基本资料',
      method: '联系方式',
    },

    copyright: '版权所有©2025惠州兴为智能科技有限公司',
    icp: '粤ICP备2023139401号'
  },
}
